import { render, staticRenderFns } from "./AuthenticationLayout.vue?vue&type=template&id=590bbfc7&"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationLayout.vue?vue&type=style&index=0&id=590bbfc7&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src141814727/src/web-authentication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590bbfc7')) {
      api.createRecord('590bbfc7', component.options)
    } else {
      api.reload('590bbfc7', component.options)
    }
    module.hot.accept("./AuthenticationLayout.vue?vue&type=template&id=590bbfc7&", function () {
      api.rerender('590bbfc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/layout/AuthenticationLayout.vue"
export default component.exports